import React from "react";

const ComiteContent = ({ title, description, members, titleColor }) => {
    // On découpe la description par ligne pour gérer les retours à la ligne (\n)
    const descriptionLines = description ? description.split('\n') : [];

    return (
        <section className="mb-12">
            {/* Titre avec une bordure verte */}
            <h2 className={`text-3xl font-semibold mb-2 flex items-center ${titleColor}`}>
                {title}
            </h2>

            {/* Description avec gestion des retours à la ligne */}
            {description && (
                <p className="text-gray-700 mb-6">
                    {descriptionLines.map((line, i) => (
                        <React.Fragment key={i}>
                            {line}
                            {i !== descriptionLines.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </p>
            )}

            {/* Liste des membres */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {members.map((member, index) => (
                    <div key={index} className="flex items-start gap-3">
                        <span className="text-greenprimary text-xl">●</span>
                        <div>
                            <p className="font-bold text-xl text-gray-900">
                                {member.grade_rev ? member.grade_rev + " " : ""}
                                {member.first_name} {member.last_name}
                            </p>

                            {/* Boucle sur les affiliations */}
                            {member.affiliations && member.affiliations.length > 0 && (
                                <div className="mt-1">
                                    {member.affiliations.map((aff, i) => (
                                        <p key={i} className="text-sm text-gray-600">
                                            - {aff.name_aff}
                                        </p>
                                    ))}
                                </div>
                            )}

                            {member.email_user && (
                                <p className="text-sm text-gray-600">{member.email_user}</p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ComiteContent;
